var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ExperimentAgreeSentence'),_vm._v(" "),_c('TextLink',{attrs:{"text":"同意して進む"},on:{"click-text":_vm.onClickAgree}}),_vm._v(" "),_c('TextLink',{attrs:{"text":"実験参加せず、利用開始する"},on:{"click-text":_vm.onClickNotAgree}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3419376a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/ExperimentAgreeCheck.vue
// module id = null
// module chunks = 